.text-container {
  margin-top: 4px;
}
